module.exports = __webpack_public_path__ + "small-logo-active.svg?aa980bc6d4135d365f1b34c5dbcae978";